import { useCallback, useEffect, useState } from 'react';

export enum ViewSize {
  Mobile,
  Tablet,
  Desktop,
  BigDesktop,
}

export const calculateView = () => {
  const viewPortWidth = window.innerWidth;
  if (viewPortWidth < 768) {
    return ViewSize.Mobile;
  }
  if (viewPortWidth >= 768 && viewPortWidth < 1024) {
    return ViewSize.Tablet;
  }
  if (viewPortWidth >= 1024 && viewPortWidth < 1440) {
    return ViewSize.Desktop;
  }

  return ViewSize.BigDesktop;
};

export function useViewSize() {
  const [viewSize, setViewSize] = useState<ViewSize>(ViewSize.Desktop);

  const setCalculatedView = useCallback(() => {
    setViewSize(calculateView());
  }, []);

  useEffect(() => {
    setCalculatedView();

    window.addEventListener('resize', () => setCalculatedView());

    return () => {
      window.removeEventListener('resize', () => setCalculatedView());
    };
  }, [setCalculatedView]);

  return viewSize;
}
